export default __webpack_public_path__ + "static/media/ceramol-olio-detergente.dc3f6a2a.png";